import React from "react";
import WithLabel from "./WithLabel";
import {workAttrList} from "../../../types/workForm";
import Pjdb1CheckBox from "../../../../../components/inputs/Pjdb1CheckBox";

export interface DeformableProps {
  // eslint-disable-next-line react/require-default-props
  value?: boolean;
  // eslint-disable-next-line react/require-default-props
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  // eslint-disable-next-line react/require-default-props
  required?: boolean;
  // eslint-disable-next-line react/require-default-props
  disabled?: boolean;
  // eslint-disable-next-line react/require-default-props
  isClear?: boolean;
}

export default function Scale(props: DeformableProps) {
  return (
    <WithLabel label={workAttrList.scale.label}>
      <Pjdb1CheckBox
        label={workAttrList.scale.meta.yes}
        name={workAttrList.scale.key}
        value={props.value ?? false}
        onChange={props.onChange}
        disabled={props.disabled}
        toolTip="モデルを1/1000にスケールする場合はチェック"
      />
    </WithLabel>
  )
}
